import type {ReactElement} from 'react'

import {useAddressWidget} from '../../hooks/useAddressWidget'
import {AddressDetails} from '../Details/Address@desktop'
import {ContactDetails} from '../Details/Contact@desktop'
import * as classes from './AddressWidget@desktop.classes'
import {useAddressWidgetProps} from './hooks/useAddressWidgetProps'
import type {Props} from './types'

export function AddressWidget(props: Props): ReactElement {
  const {isSource, pointId, addressName, contactsName} = useAddressWidgetProps(props)
  useAddressWidget(addressName, contactsName, pointId, props.config)

  return (
    <div className={classes.root}>
      <AddressDetails addressWidgetConfig={props.config} isSource={isSource} name={addressName} />
      <ContactDetails isSource={isSource} name={contactsName} />
    </div>
  )
}
